import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAuth from "../Hooks/useAuth";
import axios from "../shared";

const ReadBlog = () => {
  const { auth } = useAuth();
  const [alert, setAlert] = useState(null);
  const [values, setValues] = useState({});
  const [paragraph, setParagraph] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`blog/${id}`);
        setValues(response?.data);
        setParagraph(response?.data.description.split("\n"));
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Load Failed", "warning");
        }
      }
    };
    fetchData();
  }, []);

  const book = () => {
    navigate(`/book/doctor/${values?.author?.user}`);
  };

  return (
    <div>
      <AlertField alert={alert} />
      <div className="w-100 row row-md-cols-2 m-0 flex-column flex-md-row px-2 px-md-5 justify-content-between">
        <div className="col-md-8 bg-light mt-5 rounded">
          <h1 className="text-center py-2 mb-4 mt-2">{values?.title}</h1>
          <div className="text-center">
            <img
              src={values?.blog_image || ""}
              className="rounded mb-2 img-fluid"
              width="800"
              height="400"
              alt="doctor"
            />
          </div>
          <div className="mx-md-5 mx-2 d-flex justify-content-between">
            <h6>Dr. {values?.author?.user_detail.name}</h6>
            <p className="m-0 p-0">
              Posted On:{" "}
              {new Date(values?.posted_date).toLocaleDateString() || ""}
            </p>
          </div>
          <p className="mx-2 mx-md-5 text-capitalize">{values?.category}</p>
          <div
            className="mx-2 mx-md-5 fs-5 mb-4 letter-spacing-1"
            style={{ fontFamily: "sans-serif" }}
          >
            {paragraph.length &&
              paragraph.map((paragraph, i) => (
                <p className="m-0" key={i}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{paragraph}
                </p>
              ))}
            <label className="text-center w-100 pt-2 m-0">
              Thank you for reading.
            </label>
          </div>
        </div>
        <div className="col-md-3 position-relative">
          <div className="sticky-top" style={{ top: 3.7 + "rem" }}>
            <img
              src={values?.author?.user_detail.user_image}
              className="img-fluid rounded-start mt-5"
              width={150}
              height={150}
              alt="doctor"
            />
            <h4>Dr. {values?.author?.user_detail.name}</h4>
            <p className="fw-semibold">{values?.author?.specialization}</p>
            <p>{values?.author?.description}</p>
            {auth?.user?.roles !== 0 && auth?.user?.roles !== 1 && (
              <button className="btn btn-primary py-1" onClick={book}>
                Book Appointment
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadBlog;
